export default __webpack_public_path__ + "static/media/visa.1c9d086f.svg";